export const sayings = [
  "O Captain! My Captain! What a number!",
  "Now that's a hit",
  "Aunsh look at that beauty of a number!",
  "That no. is the meaning of life not 42!",
  "Looks like I'm winning!!",
  "Hitsnumberdian increasiosa!",
  "Feels good to see the number doesn't it ;)",
  "Cuh wat a number cuh",
  "Dayummmmm that's perfect!",
  "With great hits come great offers!"
];